<template>
  <span
    class="director__missing-info"
  >
    <v-popover
      ref="popover"
      class="d-inline"
      popover-class="director__missing-info__popover"
      trigger="hover click"
      placement="auto"
      :offset="10"
    >
      <button
        class="director__missing-info__indicator vs-btn-legacy"
        @touchstart="$_openPopover"
        @mousedown="$_handleClick"
      >
        <i
          class="fa fa-info-circle"
          aria-hidden="true"
        />
      </button>

      <template slot="popover">
        <div
          class="text-left"
          @click="$_handleClick"
        >
          {{ $_popover_text }}
        </div>
      </template>

    </v-popover>
  </span>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue';
import loginController from '@/scripts/libs/login/controller';
import viddsee from '@/scripts/viddsee';
import feedback from '@/scripts/pages/shared/legacy-pages/vs-feedback';
import { UserInfoCompat } from '@/scripts/libs/login/userResponseProcessor';
import { Nullable } from '@/scripts/models/utility-types';
import { Model } from '@viddsee/server-api-client';

const localeData = {
  en: {
    tooltip: {
      question: 'Are you part of the team for this film?',
      action: {
        user: 'Click here to',
        guest: 'Sign in and',
      },
      goal: ' complete the form to link this film in your profile.',
    },
    email: {
      title: 'Request to link my account with',
      name: 'Name',
      email: 'Email',
      video: 'Video',
    },
  },
  id: {
    tooltip: {
      question: 'Apakah Anda bagian dari tim produksi untuk film ini?',
      action: {
        user: 'Klik di sini untuk',
        guest: 'Masuk dan',
      },
      goal: ' lengkapi formulir untuk menautkan film ini ke profil Anda.',
    },
    email: {
      title: 'Permintaan untuk menautkan akun saya dengan',
      name: 'Nama',
      email: 'Email',
      video: 'Film',
    },
  },
  zh: {
    tooltip: {
      question: '您是该影片的团队成员吗？',
      action: {
        user: '点击此处并',
        guest: '登錄并',
      },
      goal: '填写表格，将该电影链接到您的个人资料中',
    },
    email: {
      title: '請求關聯我的帳戶與',
      name: '姓名',
      email: '電郵',
      video: '影片',
    },
  },
};

interface ComponentData {
  user: Nullable<UserInfoCompat>;
  isTriggeredWithTouch: boolean;
}

export default Vue.extend({
  i18n: localeData,

  props: {
    video: {
      type: Object as PropType<Model.Video.Info>,
      required: true,
    },
  },
  data(): ComponentData {
    return {
      user: null,
      isTriggeredWithTouch: false,
    };
  },
  computed: {
    // eslint-disable-next-line @typescript-eslint/camelcase
    $_popover_text(): string {
      const actionType = this.user ? 'user' : 'guest';
      return [
        this.$t('tooltip.question'),
        this.$t('tooltip.action.' + actionType) + this.$t('tooltip.goal'),
      ].join(' ');
    },
  },

  mounted() {
    loginController.getUser()
      .then((user) => {
        this.user = user;
      });
  },

  methods: {
    // eslint-disable-next-line @typescript-eslint/camelcase
    $_handleClick(): void {
      if (this.isTriggeredWithTouch) {
        this.isTriggeredWithTouch = false;
        return;
      }

      if (!this.user) {
        viddsee.ui.modal.register.open();
      } else {
        feedback.trigger({
          subject: `${this.$t('email.title')} "${this.video.title}"`,
          message: [
            `${this.$t('email.name')}: ${this.user.profile.firstName} ${this.user.profile.lastName}`,
            `${this.$t('email.email')}: ${this.user.profile.email.primaryEmail || ''}`,
            `${this.$t('email.video')}: ${this.video.title} (${this.video.id})`,
          ].join('\n'),
        }, {
          event: 'director_claim_video',
          // eslint-disable-next-line @typescript-eslint/camelcase
          user_id: this.user.id,
          // eslint-disable-next-line @typescript-eslint/camelcase
          video_id: this.video.id,
          destination: 'creator-community',
        });
      }

      (this.$refs.popover as any).hide();
    },
    // eslint-disable-next-line @typescript-eslint/camelcase
    $_openPopover(): void {
      this.isTriggeredWithTouch = true;
    },
  },
});
</script>

<style lang="scss">
.director__missing-info {

  .director__missing-info__indicator {
    padding: 0;
    overflow: visible;
    opacity: 1;
    font-size: 1rem;
    vertical-align: middle;
    color: lightgray;
  }
}
.director__missing-info__popover.popover {
  $color: rgba(black, 0.85);
  .popover-arrow { border-color: $color; }
  .popover-inner {
    background-color: $color;
    color: white;
  }
}
</style>
